export const getJobRoles = (functionId?: string) => `
{
  getJobRoles${functionId ? `(filters:{id: "${functionId}"})` : ''}{
    id,
    totalApplications,
    title,
    slug
  }
}`
